import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { IonSelect } from '@ionic/angular';
import { Real } from '../../core/models/real.model';
import { User } from '../../core/models/user.model';
import { Pick } from '../../core/models/cart/pick.model';
import { Cart } from '../../core/models/cart/cart.model';
import { Slot } from '../../core/models/cart/slot.model';
import { Combination } from '../../core/models/cart/combination.model';
import { CartService } from "../../core/services/cart.service";

import { PickSlotService } from '../../core/services/pick-slot.service';
import { ShopDetailService } from '../../core/services/shop-detail.service';
import { UtilsService } from '../../core/services/utils.service';
import { PPAuthService } from '../../core/services/auth.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, zip, of, Subject, BehaviorSubject, Subscription, combineLatest } from 'rxjs';
import { map, first, tap, filter,take } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { PhoneModalComponent } from '../../shared/phone-modal/phone-modal.component';
import { PaymentModalComponent } from '../../shared/payment-modal/payment-modal.component';
import { TermsModalComponent } from '../../shared/terms-modal/terms-modal.component';
import { ConsentModalComponent } from '../../shared/consent-modal/consent-modal.component';
import { ToastController } from '@ionic/angular';

import { ProviderServiceService } from '../../core/services/provider-service.service';
import { SearchPreferencesService } from '../../core/services/search-preferences.service';

import { environment } from '../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";

import { IonIntlTelInputModel } from 'ion-intl-tel-input';

import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

@Component({
  selector: 'app-preview',
  templateUrl: './preview.page.html',
  styleUrls: ['./preview.page.scss'],
})
export class PreviewPage implements AfterViewInit {

  
  @ViewChild('mySelect', { static: false }) mySelect: IonSelect;

  real: Real;
  pick: Pick;
  cart: Cart;
  loading = false;

  noShowRequired = false;
  noShowMaxPenaltyPerPerson = 30.00;
  paymentRequired = false;
  paymentAmount = 20.00;
  minSpendRequired = false;
  minSpendAmountPerPerson = 10.00;
  minSpendAmount = 10.00;

  cancellationPeriod = 24*60;

  groupsConfirmationRequired = false;
  commonTermsRequired = false;

  originalPartySize = null;
  hidePartySize = false;

  phone2: any = {
    dialCode: '+386',
    internationalNumber: null,
    isoCode: 'si',
    nationalNumber: null
  };

  showErrors = false;

  //Book button click stream
  public bookClickSubject: Subject<any> = new Subject();
  public bookClick$: Observable<any> = this.bookClickSubject.asObservable();

  public payedSubject: BehaviorSubject<any> = new BehaviorSubject( false );
  public payed$: Observable<any> = this.payedSubject.asObservable();
  
  public confirmedTermsSubject: BehaviorSubject<any> = new BehaviorSubject( false );
  public confirmedTerms$: Observable<any> = this.confirmedTermsSubject.asObservable();

  public savedConsentFormSubject: BehaviorSubject<any> = new BehaviorSubject( false );
  public savedConsentForm$: Observable<any> = this.savedConsentFormSubject.asObservable();

  phoneModalOpened = false;


  //Logged-in user stream
  public me$: Observable<User>;

  //private phoneModalOpened = false;

  private realSubscription: Subscription;
  private bookSubscription: Subscription;
  services$: Observable<any>;
  servicesSnapshot: {};

  toastRef: any;

  nextStepActive = false;

  total = 0.00;

  menuPick = false;

  slotCombinations$: Observable<Combination[]>;

  constructor( 
    private http: HttpClient, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private cartService: CartService, 
    private shopDetailService: ShopDetailService, 
    private pickSlotService: PickSlotService, 
    private authService: PPAuthService,
    public modalController: ModalController,
    public toastController: ToastController,
    private utilsService: UtilsService,
    private providerServiceService: ProviderServiceService,
    private searchPreferencesService: SearchPreferencesService,
    public translateService: TranslateService
  ) { 

    console.log('Constructor preview run');

  }

  ngAfterViewInit() {
    if (this.mySelect) {
      this.mySelect.ionFocus.subscribe(() => {
        setTimeout(() => {
          this.removePopoverProperty();
        }, 0);
      });
    }
  }

  removePopoverProperty() {
    const po = document.querySelector('ion-popover');
    if (po) {

      if (po.hasAttribute('popover')) {
        po.removeAttribute('popover');
      }
    }
  }



  setProduct() {



  }

  getUnixDay( dateString ) {
    return moment( dateString ).format('YYYY-MM-DD');
  }

  getUnixTime( dateTimeString ) {
    return dateTimeString.substr( dateTimeString.indexOf('T')+1 );
  }

  //@todo Check for events also, not only the location settings
  checkIfTermsShouldBeConfirmed( real: Real, pick: Pick, servicesSnapshot ) {

    this.noShowRequired = false;
    this.paymentRequired = false;
    this.minSpendRequired = false;




    if ( real.confirmationNeededPartySize && real.confirmationNeededPartySize <= pick.partySize ) {
      this.groupsConfirmationRequired = true;
    }

    //check events if pick required
    if ( pick.combination.eventPreference && pick.combination.eventPreference !== 'cannotDecide' && servicesSnapshot[ this.pick.combination.eventPreference ] ) {

      let s = servicesSnapshot[ this.pick.combination.eventPreference ];

      this.cancellationPeriod = s.cancellationPeriod;

      if ( s.noShowProtection ) {
        this.noShowRequired = true;

        if ( s.noShowMaxPenaltyPerPerson ) {
          this.noShowMaxPenaltyPerPerson = s.noShowMaxPenaltyPerPerson;
        }
        
      }

      if ( s.paymentRequired ) {
        this.paymentRequired = true;
        this.paymentAmount = pick.total;
      }

      if ( s.minSpendRequired ) {
        
        this.minSpendRequired = true;
        this.minSpendAmountPerPerson = s.minSpendAmount;

        if (real.slug === 'wonderland') {
          this.minSpendAmount = s.minSpendAmount;
        } else {
          this.minSpendAmount = s.minSpendAmount * pick.partySize;
        }
        
      }


      console.log(s.minSpendRequired);
      console.log(this.minSpendAmount);
      
      if ( s.confirmationNeededPartySize && s.confirmationNeededPartySize <= pick.partySize ) {
        this.groupsConfirmationRequired = true;
      }

    } else { //default check

      this.cancellationPeriod = real.cancellationPeriod;

      console.log('opa');
      if ( real.noShowProtection && real.hasSlotNoShowProtection( this.pick.combination.start ) ) {
        console.log('laa');
        this.noShowRequired = true;
        this.noShowMaxPenaltyPerPerson = real.noShowMaxPenaltyPerPerson;
      }

      console.log(this.noShowRequired);

      if ( real.paymentRequired ) {
        this.paymentRequired = true;
        this.paymentAmount = pick.total;
      }

      if ( real.minSpendRequired ) {
        this.minSpendRequired = true;
        this.minSpendAmountPerPerson = real.minSpendAmount;
        this.minSpendAmount = real.minSpendAmount * pick.partySize;
      }
      

    }

          /*  && output[ this.pick.combination.eventPreference ].productPickRequired
          ) {
            this.menuPick = true;
          } */


    if ( !this.groupsConfirmationRequired && !this.noShowRequired && !this.paymentRequired && !this.minSpendRequired ) {
      this.confirmedTermsSubject.next( true );
    }

  }

  ionViewWillEnter() {

    console.log('ionViewWillEnter preview run');

    //Set logged-in-user stream
    this.me$ = this.authService.me2$;

    this.cart = this.cartService.getCart();

    //If real data not ready, we should redirect to shop detail
    let realLoaded = false; 

    //real should be ready right away
    this.realSubscription = this.shopDetailService.real$.subscribe( 
      
      real =>  { 

        realLoaded = true;

        this.real = real;

        if ( this.real.productPickRequired ) {
          this.menuPick = true;
        }
        
        this.pick = this.cart.getPickByShopId( parseInt(this.real.id) );

        this.originalPartySize = this.pick.partySize;


        console.log( this.pick );
        console.log( this.pick.combination );
        console.log( this.pick.combination.eventPreference );
        if ( this.pick.combination && this.pick.combination.eventPreference && ( this.pick.combination.eventPreference === '22837' )  ) {
          this.originalPartySize = this.pick.partySize;
          this.pick.partySize = 1;
          this.hidePartySize = true;
        }
        
        if ( this.real.confirmationNeededPartySize && this.pick.partySize >= this.real.confirmationNeededPartySize ) {
          this.groupsConfirmationRequired = true;
        }

        if ( this.real.noShowProtection ) {
          this.noShowRequired = true;
        }

        //get all options for this slot
        //this.slotCombinations$ = this.pickSlotService.getSlotCombinations( this.getUnixTime( this.pick.combination.start ), this.getUnixDay( this.pick.combination.start ), this.real, this.pick.partySize );

        /*this.slotCombinations$.subscribe( result => {

          console.log(result);

        });*/

        //check if user has slot picked otherwise redirect to slot pick step
        if ( !this.pick.isCombinationPicked() ) {
          this.navigateToSlotPick()
          return;
        }


        //check events if pick required
        /*if ( this.pick.combination.eventPreference && this.pick.combination.eventPreference !== 'cannotDecide' ) {
            this.menuPick = true;
        }*/

        //check if terms should be confirmed
        //this.checkIfTermsShouldBeConfirmed( real, this.pick );
        
        
        //check if user has services picked otherwise redirect to service pick step
        /*if ( !this.pick.areServicesPicked() ) {
          this.navigateToServicePick()
          return;
        }*/

        

      }

    );

    //Real data is not ready, redirect to shop detail
    if ( !realLoaded ) {
      this.realSubscription.unsubscribe();
      this.navigateToServicePick();
    }

    this.services$ = zip(
      this.providerServiceService.getServicesForPicking( this.real.selectionItems[0].id, this.pick ),
      this.searchPreferencesService.searchPreferences$
    ).pipe(
      tap(
        ( ([categories, searchPreferences]) => {

          console.log(categories);
          console.log(searchPreferences);

          //services snapshot for deps toast
          let output = {};

          for( let s of categories ) {
            
            output[ s.id.toString() ] = s;


            if ( s.children) {

              for( let t of s.children ) {
                 output[ t.id.toString() ] = t;
              }

              if ( this.pick && this.pick.combination && this.pick.combination.eventPreference && this.pick.combination.eventPreference == s.id && s.children.length === 1 && s.productPickRequired ) {
                this.pick.emptyProducts();
                this.toggleProduct( s.children[0], s, this.pick.partySize );
              }

            }

          }

          //check events if pick required
          /*if ( this.pick.combination.eventPreference && this.pick.combination.eventPreference !== 'cannotDecide' ) {
            this.menuPick = true;
          } */

          //check events if pick required
          if ( this.pick.combination.eventPreference 
            && this.pick.combination.eventPreference !== 'cannotDecide' 
            && output[ this.pick.combination.eventPreference ] 
            && output[ this.pick.combination.eventPreference ].productPickRequired
          ) {
            this.menuPick = true;
          } 

          console.log('Evooo');

          console.log(this.authService.meSnapshot)

          //Check if we show btn
          if ( this.menuPick ) {
            this.nextStepActive = this.pick.areProductsPickedAndCombinationSet();
          } else {
            this.nextStepActive = true;
          }



          this.servicesSnapshot = output;

          //check if terms should be confirmed
          this.checkIfTermsShouldBeConfirmed( this.real, this.pick, this.servicesSnapshot );

          console.log(categories.length);
          console.log(categories[0].children.length);

          //set menus in case their is no alternative
          if ( categories.length === 1 && categories[0].children.length === 1 && this.real.productPickRequired ) {
            this.pick.emptyProducts();
            this.toggleProduct( categories[0].children[0], categories[0], this.pick.partySize );
          }

          //set menus strelec
          if ( this.pick.menuStrelec ) {
            this.pick.emptyProducts();

            console.log(categories);
            this.toggleProduct( categories[0].children[(this.pick.menuStrelec-1)], categories[0], this.pick.partySize );
          }

          
        }
        ),
      ),
      map( ([categories, searchPreferences]) => categories ),
      take(1)
    );



    let openDialogIfNotVerified = (user) => {

      console.log('openDialogIfNotVerified');
      
      if ( this.isPhoneVerified( user ) ) {
        return false;
      }


      console.log(user);
      console.log(this.isPhoneVerified( user ));

      console.log('getTop');

      //this.openPhoneModal();

      this.modalController.getTop().then(
        ( result ) => {
          //if ( undefined === result ) {
            console.log('openModal');
            this.openPhoneModal();
          //}
        }
      )

    }


    let openPaymentModalIfNotPayed = (user, payed) => {

      console.log('y');
      if ( payed || this.phoneModalOpened ) {
        return false;
      }
      
      this.modalController.getTop().then(
        ( result ) => {
          if ( undefined === result ) {
            return this.openPaymentModal();
          }
        }
      )

    }

    let userWithPhoneVerified$ = this.me$.pipe(
      tap( user => openDialogIfNotVerified( user ) ), //open dialog when phone not verified
      filter( user => ( this.isPhoneVerified( user ) ) ),  //phone verified
      first()
    );

    const book$ = combineLatest( this.me$, this.bookClick$, this.payed$, this.confirmedTerms$, this.savedConsentForm$ ).pipe(

      tap( ([ user, click, payed, confirmedTerms, savedConsentForm ]) => {

        if ( user.email === 'brez.prijave@table42.app' ) {

          if ( !this.pick.onBehalfOfName || !this.phone2 || !this.pick.onBehalfOfEmail ) {


            this.showErrors = true;
            return false;

          }

        }

        if ( !savedConsentForm ) {
          this.openConsentModal( user );
        }

        if ( !confirmedTerms && ( 
            
          this.noShowRequired 
          || this.paymentRequired 
          || this.minSpendRequired 
          || this.groupsConfirmationRequired 
          || this.commonTermsRequired ) ) {

          this.openTermsModal();

        }

      }),
      
      filter( ([ user, click, payed, confirmedTerms, savedConsentForm ]) => confirmedTerms),

      filter( ([ user, click, payed, confirmedTerms, savedConsentForm ]) => savedConsentForm),

      tap( ([ user, click, payed ]) => {
          

          console.log('combine');
          console.log(payed);
          console.log('combine end');

          if ( !this.phoneModalOpened ) {
            console.log('3');
            openDialogIfNotVerified( user );
            console.log('4');
          }

          /*if ( !payed ) {
            openPaymentModalIfNotPayed( user, payed );
          }*/

          console.log('5');

        }
      ),

      //tap( ([ user, click ]) => openDialogIfNotVerified( user ) ),
      filter( ([ user, click, payed ]) => this.isPhoneVerified( user ) /*&& payed*/ ),
      first()
    )

    this.bookSubscription = book$.subscribe( ([ user, click, payed ]) => {
      this.book( user ); 
      console.log('dismiss');
      this.closePhoneModal();
      //this.modalController.dismiss();
    })

  }

  ionViewWillLeave() {
    this.realSubscription.unsubscribe();
    this.bookSubscription.unsubscribe();
    this.phoneModalOpened = false;                                                                                      
  }

  async closePhoneModal() {
    console.log('a');
    this.phoneModalOpened = false;
    const modal = await this.modalController.getTop();
    if ( modal ) {
      console.log('b');
      this.phoneModalOpened = false;
      this.modalController.dismiss();
    }
  }

  async openPhoneModal() {

    console.log('openPhoneModal called'); 
    const modal = await this.modalController.create({
      component: PhoneModalComponent,
      cssClass: 'my-modal'
    });

    const output = await modal.present();
    this.phoneModalOpened = true;

    //this.phoneModalOpened = true;

    const { data, role } = await modal.onWillDismiss();

    if ( role === 'cancel' ) {
      this.phoneModalOpened = false;
    }

    return output;
  }

  async openPaymentModal() {

    console.log('openPaymentModal called'); 
    const modal = await this.modalController.create({
      component: PaymentModalComponent,
      cssClass: 'my-modal',
      componentProps: {
        pick: this.pick
      },
    });

    modal.present();


    const output = await modal.present();

    const { data, role } = await modal.onWillDismiss();

    console.log( data , role );

    this.payedSubject.next( true );

    return output;

  }

  async openTermsModal() {

    console.log('openTermsModal called'); 
    const modal = await this.modalController.create({
      component: TermsModalComponent,
      cssClass: 'my-modal',
      componentProps: {
        pick: this.pick,
        real: this.real,
        noShowRequired: this.noShowRequired,
        paymentRequired: this.paymentRequired,
        paymentAmount: this.paymentAmount,
        minSpendRequired: this.minSpendRequired,
        minSpendAmount: this.minSpendAmount,
        minSpendAmountPerPerson: this.minSpendAmountPerPerson,
        groupsConfirmationRequired: this.groupsConfirmationRequired,
        noShowMaxPenaltyPerPerson: this.noShowMaxPenaltyPerPerson,
        cancellationPeriod: this.cancellationPeriod,
      },
    });

    modal.present();

    const output = await modal.present();

    const { data, role } = await modal.onWillDismiss();

    console.log( data , role );

    if ( role === 'confirm' ) {
      this.confirmedTermsSubject.next( true );
    }

    //this.payedSubject.next( true );

    return output;

  }

  async openConsentModal( user ) {

    console.log('openConsentModal called'); 

    if ( !user ) {
      console.log('user is not set.'); 
      return false;
    }

    if ( user?.providerUsers ) {

      for (let pu of user.providerUsers ) {
        if ( this.activatedRoute.snapshot.params.providerId == pu.provider.id ) {
          
          if ( pu.newsletter && pu.promotionsViaSms && pu.promotionsViaEmail ) {
            this.savedConsentFormSubject.next( true );
            return true;
          }

        } 
      }

    }

    const modal = await this.modalController.create({
      component: ConsentModalComponent,
      cssClass: 'my-modal',
      componentProps: {
        user: user,
        providerId: this.activatedRoute.snapshot.params.providerId
      },
    });

    modal.present();

    const output = await modal.present();

    const { data, role } = await modal.onWillDismiss();

    console.log( data , role );

    if ( role !== 'cancel' ) {
      this.savedConsentFormSubject.next( true );
    } 

    return output;

  }


  navigateToServicePick = function() {
    this.router.navigate( [ 
      '/restavracija', 
      this.activatedRoute.snapshot.params.providerId, 
      this.activatedRoute.snapshot.params.shopSlug
    ]);
  }

  navigateToSlotPick = function() {
    this.router.navigate( [ 
      '/restavracija', 
      this.activatedRoute.snapshot.params.providerId, 
      this.activatedRoute.snapshot.params.shopSlug,
      'rezervacija',
      'izberi-termin'
    ]);
  }

  isPhoneVerified = function( user: User ): boolean {
    return user && !!user.phone && user.phone.length > 10  &&  ( user.phoneVerified || user.phone.substr(0,4) !== '+386' );
  }


  fromPhoneObjToPPNumber( phoneObj: IonIntlTelInputModel ) {

    if ( !phoneObj  || !phoneObj.internationalNumber ) {
      return '';
    }

    var formattedIntArray = phoneObj.internationalNumber.split(" ");

    var intPrefix = formattedIntArray.shift();

    return intPrefix + ' ' + formattedIntArray.join('');    

  }

  book( user ) {
    this.closePhoneModal();

    this.loading = true;

    //filter emojis
    this.pick.setCustomerNotes( this.utilsService.filterEmojis( this.pick.bookingPostObject.customerNotes ) );

    /*if ( this.pick.combination.eventPreference ) {
      event = '?event=' + this.pick.combination.eventPreference;  
    }*/

    //hack for union kviz like events
    if ( this.hidePartySize && this.originalPartySize && this.originalPartySize !== this.pick.partySize ) {
      this.pick.partySize = this.originalPartySize;
    }

    if ( this.phone2  && this.phone2.internationalNumber ) {
      this.pick.onBehalfOfPhone = this.fromPhoneObjToPPNumber(this.phone2);
    }

    this.http.post(
      environment.apiUrl + '/users/' + this.authService.me.id + '/bookings', 
      this.pick.bookingPostObject, { observe: 'response' }
    )

    .subscribe( (response: HttpResponse<any>) => {
      console.log('booking saved');
      const loc = response.headers.get('location');
      const bookingId = loc.substr( loc.lastIndexOf('/') + 1 );
      this.cart.reset();

      this.loading = false;

      this.router.navigate( [ 
        '/restavracija', 
        this.activatedRoute.snapshot.params.providerId, 
        this.activatedRoute.snapshot.params.shopSlug,
        'rezervacija',
        'narejena',
        bookingId
      ]);

      console.log('navigacija opravljena');
      
    }, error => {
      console.log(error);
      this.loading = false;

      this.presentToast(  this.translateService.instant( 'PREVIEW.TOAST_JUST_BOOKED') );

      this.router.navigate( ['/restavracija', this.activatedRoute.snapshot.params.providerId, this.activatedRoute.snapshot.params.shopSlug, 'rezervacija', 'izberi-termin'] );
    }); 

  }


  toggleProduct( product, category, qty ) {

    if ( this.toastRef ) {
      this.toastRef.dismiss();
    }

    //Maybe a place to reset combination products with prices???
    /*if (this.pick.combination) { 
      delete this.pick.combination;
    }*/

    this.pick.toggleProduct( product, category, qty );

    this.paymentAmount = this.pick.total;

    /*let text = this.depsService.getMissingDeps( attendee, this.real, this.servicesSnapshot );

    if ( text && text.length > 0 ) {
      attendee.setDepsIssue(true);
      this.presentToast(text[0]);

    } else {
      attendee.setDepsIssue(false);
    }*/

    //output event that services are picked and there are no dependency issues

    

    this.nextStepActive = this.pick.areProductsPickedAndCombinationSet();


    if ( this.pick?.shopId && Number(this.pick.shopId) === 2742 && category && category.id && ( Number(category.id) === 21666 || Number(category.id) === 18675 ) ) { //PEN

        if ( !this.pick.areTooManyProductsPicked() && this.pick.areDifferentProductsPicked() ) {

          this.nextStepActive = false;
           
          if ( this.hidePartySize ) {

            this.translateService.get('PREVIEW.TOAST_PICKED_DIFFERENT_HIDDEN_PARTYSIZE', { numOfOptions: this.pick.partySize }).subscribe((translatedText: string) => {
              this.presentToast(translatedText);
            });

          } else {

            //Izbrali ste preveč menijev. Vaša rezervacija je za {partySize, plural, =0{0 oseb} one{1 osebo} two{2 osebi} three{# osebe} four{# osebe} other{# oseb}}
            this.translateService.get('PREVIEW.TOAST_PICKED_DIFFERENT', { partySize: this.pick.partySize }).subscribe((translatedText: string) => {
              this.presentToast(translatedText);
            });

          }

        }

    }


    if ( this.pick.areTooManyProductsPicked() ) {


      let word = '';
      switch ( this.pick.partySize ) {

        case 1:
          word = 'osebo';
          break;

        case 2:
          word = 'osebi';
          break;

        case 3:
          word = 'osebe';

        case 5:
          word = 'oseb';
          break;

      }

      if ( this.hidePartySize ) {

        this.translateService.get('PREVIEW.TOAST_PICKED_TOO_MANY_HIDDEN_PARTYSIZE', { numOfOptions: this.pick.partySize }).subscribe((translatedText: string) => {
          this.presentToast(translatedText);
        });

      } else {

        //Izbrali ste preveč menijev. Vaša rezervacija je za {partySize, plural, =0{0 oseb} one{1 osebo} two{2 osebi} three{# osebe} four{# osebe} other{# oseb}}
        this.translateService.get('PREVIEW.TOAST_PICKED_TOO_MANY', { partySize: this.pick.partySize }).subscribe((translatedText: string) => {
          this.presentToast(translatedText);
        });

      }
     
      
    }
    
    console.log( this.nextStepActive );
  }


  async presentToast( text ) {
    this.toastRef = await this.toastController.create({
      message: text,
      duration: 10000,
      color: 'danger'
    });
    this.toastRef.present();
  }


  formatDescription( text ) {
    return text.replace(/\[BR\]/g, "<br/>");
  }

}
